import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  root: {
    position: 'fixed',
    zIndex: 999999,
    height: '100%',
    width: '100%',
    '& svg circle': {
      stroke: '#c5281c',
    },
  },
});
